module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3894461559/src/~/babel-runtime/core-js/object/define-property.js
// module id = 0hsw
// module chunks = 6